<template>
  <div class="show-card">
    <div class="show-card__inner">
      <!-- loading spinner -->
      <div class="spinner" v-if="filteredMumblCardsLength === null">
        <div class="bounce1"></div>
        <div class="bounce2"></div>
        <div class="bounce3"></div>
      </div>

      <!-- MUMBL_CARD -->
      <vue-swing class="mumblcard-wrapper"
                 @throwout="onThrowout"
                 @throwoutend="onThrowOutEnd"
                 @dragstart="onDragStart"
                 @dragmove="onDragMove"
                 :config="config"
                 ref="vueswing"
      >
        <div class="mumblcard stack noselect" v-for="(card, index) in filteredCardsByGender" :key="index" :data-index="index">
          <template v-if="index > (filteredMumblCardsLength - 5)">
            <div class="mumblcard__inner">
              <!-- Waves -->
              <div class="mumblcard__wave mumblcard__wave-01"></div>
              <div class="mumblcard__wave mumblcard__wave-02"></div>

              <!-- <p style="display: block; margin-top: 60px;">INDEX: {{ index }}</p>
              <br><br>
              <p style="display: block; margin-top: 60px;">LENGTH: {{ filteredMumblCardsLength - 4 }}</p> -->

              <!-- mumblcard front -->
              <div class="mumblcard-side mumblcard-front">
                <!-- <div class="mumblcard__btn logo" @click="cardFlip"> -->
                <div class="mumblcard__btn logo">
                  <i class="material-icons gender icon male" data-gender="male" v-if="card.gender === 'male'"></i>
                  <i class="material-icons gender icon female" data-gender="female" v-if="card.gender === 'female'"></i>
                  <i class="material-icons gender icon unisex" data-gender="unisex" v-if="card.gender === 'unisex'"></i>
                </div>

                <div class="mumblcard__content">
                  <div class="mumblcard__name-wrapper">
                    <span class="mumblcard__name name">{{ card.name }}</span>
                  </div>
                  <div class="mumblcard__origin-wrapper">
                    <span class="mumblcard__origin origin">{{ card.origin }}</span>
                  </div>

                  <!-- <div class="mumblcard__btn info" @click="cardFlip">
                      <i class="material-icons gender icon front"></i>
                  </div> -->
                </div>
              </div>

              <!-- mumblcard back -->
              <div class="mumblcard-side mumblcard-back">
                <div class="mumblcard__content">
                  <div class="mumblcard__btn logo" @click="cardFlip">
                    <i class="material-icons gender icon male" data-gender="male" v-if="card.gender === 'male'"></i>
                    <i class="material-icons gender icon female" data-gender="female" v-if="card.gender === 'female'"></i>
                    <i class="material-icons gender icon unisex" data-gender="unisex" v-if="card.gender === 'unisex'"></i>
                  </div>

                  <div class="mumblcard__name-wrapper">
                    <span class="mumblcard__name name">{{ card.name }}</span>
                  </div>
                  <div class="mumblcard__origin-wrapper">
                    <span class="mumblcard__origin origin">{{ card.origin }}</span>
                  </div>
                  <div class="mumblcard__meaning-wrapper">
                    <span class="mumblcard__meaning meaning">{{ card.meaning }}</span>
                  </div>

                  <div class="mumblcard__btn info" @click="cardFlip">
                    <i class="material-icons gender icon back"></i>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </vue-swing>

      <!-- empty card stack  -->
      <p class="no-cards-message" v-if="filteredMumblCardsLength != null">
        <span class="no-cards-message__big">Whoop, you did it!</span>
        There are no more Names in Stack.
      </p>

      <!-- card icons -->
      <i class="icon-like"></i>
      <i class="icon-dislike"></i>
      <i class="icon-swipe-legend"></i>
    </div>

    <!-- FAVORITES -->
    <div class="mumblfav-wrapper favorites">
            <span class="btn-floating trigger" @click="toggleMenuFav">
                <i class="icon"></i>
            </span>
      <div class="mumblfav-wrapper__inner">
        <h2 class="white-text">Favoriten</h2>
        <ul>
          <li class="mumblfav card favorite" v-for="fav in sortAbcAllFavs">
            <div class="mumblfav__inner card-content">
              <span class="mumblfav__name">{{ fav.name }}</span>
              <span class="mumblfav__icon-wrapper icon-wrapper gender">
                  <i class="material-icons gender icon male" data-gender="male" v-if="fav.gender === 'male'"></i>
                  <i class="material-icons gender icon female" data-gender="female" v-if="fav.gender === 'female'"></i>
                  <i class="material-icons gender icon unisex" data-gender="unisex" v-if="fav.gender === 'unisex'"></i>
              </span>
              <span class="btn-floating delete" @click="deleteFav(fav.name)">
                  <i class="material-icons icon">delete</i>
              </span>
              <span class="btn-floating more" @click="toggleFav">
                  <i class="material-icons icon">keyboard_arrow_down</i>
              </span>
              <div class="mumblfav__toggle">
                <p class="mumblfav__origin">{{ fav.origin }}</p>
                <p class="mumblfav__meaning">{{ fav.meaning }}</p>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <!-- FILTER -->
    <div class="mumblfilter">
            <span class="btn-floating trigger" @click="toggleMenuFilter">
                <i class="icon"></i>
            </span>

      <div class="mumblfilter__inner">
        <h2 class="white-text">Filter by Gender</h2>
        <div class="mumblfilter__btn-wrapper">
          <div class="mumblfilter__gender is-active" @click="filterByGender('all', $event)">
            <div class="mumblfilter__btn">
              <i class="mumblfilter__btn-icon all"></i>
            </div>
            <span class="mumblfilter__gender-text">All</span>
          </div>
          <div class="mumblfilter__gender" @click="filterByGender('male', $event)">
            <div class="mumblfilter__btn">
              <i class="mumblfilter__btn-icon male"></i>
            </div>
            <span class="mumblfilter__gender-text">Male</span>
          </div>
          <div class="mumblfilter__gender" @click="filterByGender('female', $event)">
            <div class="mumblfilter__btn">
              <i class="mumblfilter__btn-icon female"></i>
            </div>
            <span class="mumblfilter__gender-text">Female</span>
          </div>
          <div class="mumblfilter__gender" @click="filterByGender('unisex', $event)">
            <div class="mumblfilter__btn">
              <i class="mumblfilter__btn-icon unisex"></i>
            </div>
            <span class="mumblfilter__gender-text">Unisex</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
   import firebase from 'firebase'
   import db from '@/firebase/init'
   import VueSwing from 'vue-swing'
   import PerfectScrollbar from 'perfect-scrollbar'


   export default {
      name: 'ShowMumblCard',
      props: ['Active'],
      components: {
         VueSwing
      },
      // local data
      data() {
         return {
            appLoaded: null,
            cardPos: null,
            mumblCards: [],
            filteredMumblCardsLength: null,
            allFavNames: [],
            allFavs: [],
            name: null,
            origin: null,
            meaning: null,
            gender: null,
            filterGender: 'all',
            userID: null,
            config: {
               allowedDirections: [
                  VueSwing.Direction.LEFT,
                  VueSwing.Direction.RIGHT
               ],
               minThrowOutDistance: 2000,
               maxThrowOutDistance: 2000,
               throwOutConfidence: (xOffset, yOffset, element) => {
                  // reduce dragmove distance to remove card from stack onThrowout function (important for functionallity on mobile devices)
                  const xConfidence = Math.min(Math.abs(xOffset) / (element.offsetWidth - 150), 1);
                  const yConfidence = Math.min(Math.abs(yOffset) / element.offsetHeight, 1);

                  return Math.max(xConfidence, yConfidence);
               }
            }
         }
      },
      computed: {
         randomMumblCards() {
            return this.mumblCards.sort(function () {
               return 0.5 - Math.random()
            });
         },
         sortAbcAllFavs() {
            function compare(a, b) {
               if (a.name < b.name)
                  return -1;
               if (a.name > b.name)
                  return 1;
               return 0;
            }

            // save in local data allFavs
            return this.allFavs.sort(compare);
         },
         filteredCardsByGender() {
            return this.randomMumblCards.filter(card => {
               if (this.filterGender === 'all') {
                  // return all cards
                  return true
               } else {
                  // return just the matching gender cards
                  return card.gender == this.filterGender
               }
            })
         },
      },
      // local functions
      methods: {
         onDragStart({target}) {
            // get x position of target
            let box = target.getBoundingClientRect();
            let body = document.body;
            let docEl = document.documentElement;
            let scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;
            let clientLeft = docEl.clientLeft || body.clientLeft || 0;
            let left = parseInt(box.left + scrollLeft - clientLeft, 10);

            // store x position of target in data
            this.cardPos = left
         },
         onDragMove({target}) {
            // get x position of target
            let box = target.getBoundingClientRect();
            let body = document.body;
            let docEl = document.documentElement;
            let scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;
            let clientLeft = docEl.clientLeft || body.clientLeft || 0;
            let left = parseInt(box.left + scrollLeft - clientLeft, 10);

            // drag direction left
            if (left < (this.cardPos - 50)) {
               $(target).parent().parent().find('.icon-like').removeClass('is-active')
               $(target).find('.gender.icon').removeClass('is-liked')
               $(target).find('.gender.icon').addClass('is-disliked')
               $(target).parent().parent().find('.icon-dislike').addClass('is-active')
            }
            // rag direction right
            else if (left > (this.cardPos + 50)) {
               $(target).parent().parent().find('.icon-dislike').removeClass('is-active')
               $(target).find('.gender.icon').removeClass('is-disliked')
               $(target).find('.gender.icon').addClass('is-liked')
               $(target).parent().parent().find('.icon-like').addClass('is-active')
            } else {
               $(target).find('.gender.icon').removeClass('is-disliked')
               $(target).find('.gender.icon').removeClass('is-liked')
               $(target).parent().parent().find('.icon-dislike').removeClass('is-active')
               $(target).parent().parent().find('.icon-like').removeClass('is-active')
            }
         },
         onThrowOutEnd() {
            // after card is thrwon out delete this card from array
            this.filteredCardsByGender.pop()
            // update array length to refill card stack by if condition in in for loop (line 10 to 11)
            this.filteredMumblCardsLength = this.filteredCardsByGender.length

            // randomise colorTheme
            let colorTheme = 'jellyfish is-frontend'
            let randomise = Math.random()

            if (randomise > 0.33 && randomise <= 0.66) {
               colorTheme = "squirrel is-frontend"
            }
            // else if ( randomise > 0.25 && randomise <= 0.375 ) {
            //     colorTheme = 'frog is-frontend'
            // }
            // else if ( randomise > 0.5 && randomise <= 0.625 ) {
            //     colorTheme = 'honeybee is-frontend'
            // }
            else if (randomise > 0.66 && randomise <= 1) {
               colorTheme = 'flamingo is-frontend'
            }
            // else if ( randomise > 0.75 && randomise <= 0.875 ) {
            //     colorTheme = 'ladybeetle is-frontend'
            // }
            // else if ( randomise > 0.875 && randomise <= 1 ) {
            //     colorTheme = 'octopus is-frontend'
            // }
            else {
               colorTheme = 'jellyfish is-frontend'
            }

            const body = $('body')
            body.removeAttr('class');
            body.addClass(colorTheme)
         },
         onThrowout({target, throwDirection}) {
            // save to local data
            this.name = target.querySelectorAll('.name')[0].innerText
            this.origin = target.querySelectorAll('.origin')[0].innerText
            this.meaning = target.querySelectorAll('.meaning')[0].innerText
            this.gender = target.querySelectorAll('.gender')[0].dataset.gender

            // get local array of all favorite Names and check if the dragged name is already in the favorite Names array
            let isAlreadyInFavs = this.allFavNames.includes(this.name)

            // if drag name to the right and dragged name is not in favorites add the name and belonging data to firestore favorites
            if (throwDirection === VueSwing.Direction.RIGHT && !isAlreadyInFavs) {
               // push dragged name to local array allFavNames
               this.allFavNames.push(this.name)

               // set favorite name to each favorite in firebase database as ID
               const favID = this.name
               const favorites = {}
               favorites[favID] = {
                  name: this.name,
                  origin: this.origin,
                  meaning: this.meaning,
                  gender: this.gender,
               }
               const favs = {
                  favorites
               }
               // merge dragged favorite to database
               db.collection('users').doc(this.userID).set(favs, {merge: true})
               // after data is submitted
                   .then(() => {

                      // push dragged object-data to local array allFavs
                      this.allFavs.push({
                         name: this.name,
                         origin: this.origin,
                         meaning: this.meaning,
                         gender: this.gender,
                      })

                      let likeMessage = 'I love '
                      let randomise = Math.random()

                      if (randomise > 0.2 && randomise <= 0.4) {
                         likeMessage = "I'm crazy about "
                      } else if (randomise > 0.4 && randomise <= 0.6) {
                         likeMessage = 'I really like '
                      } else if (randomise > 0.6 && randomise <= 0.8) {
                         likeMessage = 'I would kill for '
                      } else if (randomise > 0.8 && randomise <= 1) {
                         likeMessage = 'I would die for '
                      } else {
                         likeMessage = 'I love '
                      }
                      // give feedback via toast-message
                      M.toast({
                         html: likeMessage + this.name + '!',
                         displayLength: 1500,
                         classes: 'toast-success'
                      })
                   })
                   // if something doesn't work, output an error in the console
                   .catch(err => {
                      console.log(err);
                   })
            } else if (throwDirection === VueSwing.Direction.RIGHT && isAlreadyInFavs) {
               // give feedback via toast-message
               M.toast({
                  html: 'You already love ' + this.name + '.',
                  displayLength: 1500,
                  classes: 'toast-warning'
               })
            } else {
               let hateMessage = ' sucks!'
               let randomise = Math.random()

               if (randomise > 0.2 && randomise <= 0.4) {
                  hateMessage = ' is really odd!'
               } else if (randomise > 0.4 && randomise <= 0.6) {
                  hateMessage = ' is more than strange!'
               } else if (randomise > 0.6 && randomise <= 0.8) {
                  hateMessage = ' is unlovely!'
               } else if (randomise > 0.8 && randomise <= 1) {
                  hateMessage = ' is super dry!'
               } else {
                  hateMessage = ' sucks!'
               }

               // give feedback via toast-message
               M.toast({
                  html: this.name + hateMessage,
                  displayLength: 1500,
                  classes: 'toast-error'
               })
            }
         },
         toggleMenuFav(e) {
            const $this = $(e.target)
            const $menuFav = $this.parent()
            // get trigger from menu filter
            const $menuFilter = $this.parent().next()
            const $menuFilterTrigger = $this.parent().next().children('.trigger')

            // hide filter trigger
            $menuFilterTrigger.toggleClass('is-hidden')

            $menuFav.toggleClass('is-active')
         },
         toggleFav(e) {
            const $this = $(e.target)
            const $thisHiddenContent = $this.next()

            $this.toggleClass('is-active');
            $thisHiddenContent.slideToggle(50)
         },
         deleteFav(favName) {
            this.allFavNames = this.allFavNames.filter(name => {
               // return true for all names which not macthes and save them in local data allFavNames
               return name != favName
            })

            this.allFavs = this.allFavs.filter(fav => {
               // return true for all favorites which not macthes and save them in local data favorites
               return fav.name != favName
            })

            // covert local array allFavs to an object which is needed for updating the remote firebase database
            let favs = {
               // create an empty object named favorites
               favorites: {}
            }
            this.allFavs.forEach(fav => {
               // write each fav with the key (name) to the created object favorites
               favs.favorites[fav.name] = fav
            })

            // update the firebase databse with the local modified data
            db.collection('users').doc(this.userID).update(favs)
                .then(() => {
                   // feedback via toast
                   M.toast({
                      html: 'Favorite deleted',
                      displayLength: 1500,
                      classes: 'toast-error'
                   })
                })
         },
         toggleMenuFilter(e) {
            const $this = $(e.target)
            const $menuFav = $this.parent()
            $menuFav.toggleClass('is-active');
         },
         filterByGender(gender, e) {
            let self = this
            let $this = $(e.target)
            let $filterAll = $('.mumblfilter__gender')

            $filterAll.removeClass('is-active')
            $this.addClass('is-active')
            self.filterGender = gender

            this.filteredMumblCardsLength = this.filteredCardsByGender.length
         },
         cardFlip(e) {
            let $this = $(e.target)
            let $thisMumblCard = $this.closest('.mumblcard__inner');

            $thisMumblCard.toggleClass('flip')
         }
      },
      // lifecycle-hook (fires before components are rendered)
      created() {
         // fetch data mumblcards from firestore
         db.collection('mumblCards').get()
             .then(snapshot => {

                snapshot.forEach(doc => {
                   // save each card object from Firestore in variable card
                   let card = doc.data()
                   // save auto generated doc ID from firestore to local card data
                   card.id = doc.id
                   //get empty mumblCards array from local data and push card object from firestore in it
                   this.mumblCards.push(card)
                })
                // get length of computed mumblcards array
                this.filteredMumblCardsLength = this.filteredCardsByGender.length;
             })

         // get ID from current logged in user
         this.userID = firebase.auth().currentUser.uid

         db.collection('users').doc(this.userID).get()
             .then(snapshot => {
                let favs = snapshot.data().favorites
                // convert object in an array for further handling
                Object.keys(favs).forEach(key => {
                   let fav = favs[key]
                   // get empty allFavNames array from local data and push all names from firestore in it
                   this.allFavNames.push(fav.name)
                   // get empty allFavs array from local data and push each favorite objects from firestore in it
                   this.allFavs.push(fav)
                });
             })
      },
      mounted() {
         // init styled scrollbar for favMenu
         const ps = new PerfectScrollbar('.mumblfav-wrapper__inner', {
            wheelSpeed: 1,
            wheelPropagation: false,
            minScrollbarLength: 20
         });

         // randomise colorTheme
         let colorTheme = 'jellyfish is-frontend'
         let randomise = Math.random()

         if (randomise > 0.33 && randomise <= 0.66) {
            colorTheme = "squirrel is-frontend"
         }
         // else if ( randomise > 0.25 && randomise <= 0.375 ) {
         //     colorTheme = 'frog is-frontend'
         // }
         else if (randomise > 0.33 && randomise <= 0.66) {
            colorTheme = 'honeybee is-frontend'
         } else if (randomise > 0.66 && randomise <= 1) {
            colorTheme = 'flamingo is-frontend'
         }
         // else if ( randomise > 0.75 && randomise <= 0.875 ) {
         //     colorTheme = 'ladybeetle is-frontend'
         // }
         // else if ( randomise > 0.875 && randomise <= 1 ) {
         //     colorTheme = 'octopus is-frontend'
         // }
         else {
            colorTheme = 'jellyfish is-frontend'
         }

         const body = $('body')
         body.removeAttr('class');
         body.addClass(colorTheme)
      }
   }
</script>


<style lang="scss">

  @mixin base-only {
    @media only screen and (max-width: #{$w-base-max}) {
      @content;
    }
  }

  @mixin small {
    @media only screen and (min-width: #{$w-small-min}) {
      @content;
    }
  }

  @mixin small-only {
    @media only screen and (min-width: #{$w-small-min}) and (max-width: #{$w-small-max}) {
      @content;
    }
  }

  @mixin medium {
    @media only screen and (min-width: #{$w-medium-min}) {
      @content;
    }
  }

  @mixin medium-only {
    @media only screen and (min-width: #{$w-medium-min}) and (max-width: #{$w-medium-max}) {
      @content;
    }
  }

  @mixin large {
    @media only screen and (min-width: #{$w-large-min}) {
      @content;
    }
  }

  @mixin large-only {
    @media only screen and (min-width: #{$w-large-min}) and (max-width: #{$w-large-max}) {
      @content;
    }
  }

  @mixin xlarge {
    @media only screen and (min-width: #{$w-xlarge-min}) {
      @content;
    }
  }

  @keyframes rotate-out-bear {
    0% {
      transform: scale(1) rotate(0);
    }
    37% {
      transform: scale(0.9) rotate(23deg);
    }
    67% {
      transform: scale(0.9) rotate(-23deg);
    }
    100% {
      transform: scale(1) rotate(0);
    }
  }

  @keyframes rotate-in-bear {
    0% {
      transform: scale(1);
    }
    70% {
      transform: scale(1.3);
    }
    100% {
      transform: scale(1);
    }
  }

  @keyframes pulse-like {
    0% {
      transform: scale(1);
      opacity: 0;
    }
    70% {
      transform: scale(2);
      opacity: 0.3;
    }
    100% {
      transform: scale(1);
      opacity: 0;
    }
  }

  @keyframes pulse-dislike {
    0% {
      transform: scale(1);
      opacity: 0;
    }
    70% {
      transform: scale(2);
      opacity: 0.3;
    }
    100% {
      transform: scale(1);
      opacity: 0;
    }
  }

  $c-white: #ffffff;
  $c-black: #000000;

  $w-base-max: 480px;

  $w-small-min: 481px;
  $w-small-max: 960px;

  $w-medium-min: 961px;
  $w-medium-max: 1360px;

  $w-large-min: 1361px;
  $w-large-max: 1920px;

  $w-xlarge-min: 1921px;

  .show-card {

    &__inner {
      position: relative;
      max-width: 400px;
      margin: 0 auto;
      margin-top: 10%;
    }

    .icon-like {
      display: block;
      opacity: 0;
      position: absolute;
      z-index: 10;
      top: 40%;
      right: 0px;
      transform: translateY(-50%);
      width: 140px;
      height: 100px;
      background-repeat: no-repeat;
      background-size: contain;
      background-position: bottom;
      background-image: url('../../assets/icon-heart.svg');
      pointer-events: none;

      @include medium {
        top: 60%;
        right: -200px;
      }

      &.is-active {
        animation: 0.5s pulse-like cubic-bezier(0, 1.11, 1, 1);
      }
    }

    .icon-dislike {
      display: block;
      opacity: 0;
      position: absolute;
      z-index: 10;
      top: 40%;
      left: 0px;
      transform: translateY(-50%);
      width: 140px;
      height: 100px;
      background-repeat: no-repeat;
      background-size: contain;
      background-position: bottom;
      background-image: url('../../assets/icon-heart-thunder.svg');
      pointer-events: none;

      @include medium {
        top: 60%;
        left: -200px;
      }

      &.is-active {
        animation: 0.5s pulse-dislike cubic-bezier(0, 1.11, 1, 1);
      }
    }

    .icon-swipe-legend {
      display: none;

      @include medium {
        display: block;
        opacity: 0.15;
        position: absolute;
        bottom: -200px;
        left: 50%;
        transform: translateX(-50%);
        width: 140px;
        height: 100px;
        background-repeat: no-repeat;
        background-size: contain;
        background-position: bottom;
        background-image: url('../../assets/icon-swipe-legend.svg');
      }
    }

    .no-cards-message {
      opacity: 0.5;
      display: block;
      text-align: center;
      position: absolute;
      top: 40%;
      padding: 0 2rem;
      font-family: 'Fira Sans', sans-serif;
      font-size: 1.2rem;
      line-height: 1.4em;
      font-style: italic;
      color: $c-white;

      @include medium {
        padding: 0 1.6em;
        font-size: 1.6rem;
      }

      &__big {
        display: block;
        margin-bottom: 0.4em;
        font-size: 2rem;
        line-height: 1em;

        @include medium {
          font-size: 2.4rem;
        }
      }
    }

    .mumblcard-wrapper {
      position: relative;
      width: 90%;
      max-width: 280px;
      height: 320px;
      margin: 0 auto;

      @include small {
        width: 340px;
        max-width: none;
        height: 420px;
      }
    }

    .mumblcard {
      position: absolute;
      z-index: 1;
      top: 0px;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: 10px;

      @include medium {
        top: 60px;
      }

      &:nth-last-child(4) {
        transform: rotate(3deg);

        .mumblcard__inner {
          -webkit-box-shadow: 0px 0px 4px 2px rgba(0, 0, 0, 0.125);
          -moz-box-shadow: 0px 0px 4px 2px rgba(0, 0, 0, 0.125);
          box-shadow: 0px 0px 4px 2px rgba(0, 0, 0, 0.125);
        }
      }

      &:nth-last-child(3) {
        transform: rotate(-3deg);

        .mumblcard__inner {
          -webkit-box-shadow: 0px 0px 6px 3px rgba(0, 0, 0, 0.1);
          -moz-box-shadow: 0px 0px 6px 3px rgba(0, 0, 0, 0.1);
          box-shadow: 0px 0px 6px 3px rgba(0, 0, 0, 0.1);
        }
      }

      &:nth-last-child(2) {
        // transition: transform 0.25s ease-in-out;
        transform: rotate(0deg);

        .mumblcard__inner {
          -webkit-box-shadow: 0px 0px 8px 4px rgba(0, 0, 0, 0.075);
          -moz-box-shadow: 0px 0px 8px 4px rgba(0, 0, 0, 0.075);
          box-shadow: 0px 0px 8px 4px rgba(0, 0, 0, 0.075);
        }
      }

      &:nth-last-child(1) {
        .mumblcard__inner {
          -webkit-box-shadow: 0px 0px 10px 5px rgba(0, 0, 0, 0.075);
          -moz-box-shadow: 0px 0px 10px 5px rgba(0, 0, 0, 0.075);
          box-shadow: 0px 0px 10px 5px rgba(0, 0, 0, 0.075);
        }
      }

      &__inner {
        transform-style: preserve-3d;
        transition: transform 0.3s ease-in-out;
        position: absolute;
        z-index: 1;
        top: 0;
        left: 0;
        display: flex;
        justify-content: center;
        width: 100%;
        height: 100%;
        border-radius: 10px;

        .mumblcard__wave {
          position: absolute;
          bottom: 0;
          border-bottom-left-radius: 10px;
          border-bottom-right-radius: 10px;
          width: 100%;
          height: 300px;
          background-repeat: no-repeat;
          background-size: contain;
          background-position: bottom;

          &-01 {
            background-image: url('../../assets/wave-shape-01.svg');
          }

          &-02 {
            background-image: url('../../assets/wave-shape-02.svg');
          }
        }

        &.flip {
          transform: rotateY(180deg) !important;

          .mumblcard__wave {
            display: none,
          }
        }
      }

      .mumblcard-side {
        position: absolute;
        width: 100%;
        height: 100%;
      }

      .mumblcard-front {
        //backface-visibility: hidden;
        display: flex;
        align-items: center;
        justify-content: center;

        .mumblcard__content {
          width: 90%;
          margin-top: -3rem;

          @include small {
            width: 80%;
          }
        }

        .mumblcard__name-wrapper {
          text-align: center;
        }

        .mumblcard__name {
          font-family: 'Lobster', cursive;
          font-size: 3rem;
          line-height: 1em;
          color: $c-white;
        }

        .mumblcard__origin-wrapper {
          opacity: 0.8;
          margin-top: 1rem;
          text-align: center;
        }

        .mumblcard__origin {
          font-family: 'Fira Sans', sans-serif;
          font-size: 1.3rem;
          line-height: 1em;
          font-style: italic;
          color: $c-white;
        }

        .mumblcard__meaning-wrapper {
          display: block;
          margin: 3em 0;
          text-align: left;
        }

        .mumblcard__meaning {
          font-size: 1rem;
          color: $c-white;
        }

        .mumblcard__gender-wrapper {
          text-align: center;
        }

        .mumblcard__gender {
          font-size: 2rem;
          color: $c-white;
        }
      }

      .mumblcard-back {
        backface-visibility: hidden;
        transform: rotateY(180deg);

        .mumblcard__content {
          padding: 80px 3rem;
        }

        .mumblcard__name-wrapper {
          text-align: center;
        }

        .mumblcard__name {
          font-family: 'Lobster', cursive;
          font-size: 2.2rem;
          line-height: 1em;
          color: $c-white;
        }

        .mumblcard__origin-wrapper {
          margin-top: 0em;
          text-align: center;
        }

        .mumblcard__origin {
          font-family: 'Fira Sans', sans-serif;
          font-size: 1.1rem;
          font-style: italic;
          color: $c-white;
        }

        .mumblcard__meaning-wrapper {
          display: block;
          margin: 2.5em 0;
          text-align: center;
        }

        .mumblcard__meaning {
          opacity: 0.7;
          font-family: 'Titillium Web', sans-serif;
          font-size: 1.1rem;
          color: $c-white;
        }

        .mumblcard__gender-wrapper {
          text-align: center;
        }

        .mumblcard__gender {
          font-size: 2rem;
          color: $c-white;
        }
      }

      &__btn {
        // cursor: pointer;
        //transition: background-color 0.15s ease-in-out;
        position: absolute;
        left: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        -webkit-box-shadow: 0px 0px 10px 2px rgba(0, 0, 0, 0.2);
        -moz-box-shadow: 0px 0px 10px 2px rgba(0, 0, 0, 0.2);
        box-shadow: 0px 0px 10px 2px rgba(0, 0, 0, 0.2);

        &.logo {
          top: 0;
          transform: translate(-50%, -50%);
          width: 80px;
          height: 80px;

          .icon {
            width: 44px;
            height: 44px;
            background-repeat: no-repeat;
            background-size: contain;
            background-position: bottom;

            &.male {
              background-image: url('../../assets/icon-mumbl-male.svg');
            }

            &.female {
              background-image: url('../../assets/icon-mumbl-female.svg');
            }

            &.unisex {
              background-image: url('../../assets/icon-mumbl-unisex.svg');
            }

            &.is-liked {
              animation: 0.5s rotate-in-bear cubic-bezier(0, 1.11, 1, 1);
            }

            &.is-disliked {
              animation: 0.5s rotate-out-bear cubic-bezier(0, 1.11, 1, 1);
            }
          }
        }

        &.info {
          bottom: 0;
          transform: translate(-50%, 50%);
          width: 50px;
          height: 50px;
          display: flex;
          align-items: center;
          justify-content: center;

          .icon {
            background-repeat: no-repeat;
            background-size: contain;
            background-position: bottom;

            &.front {
              width: 26px;
              height: 22px;
              background-image: url('../../assets/icon-arrows-flip.svg');
            }

            &.back {
              width: 17px;
              height: 17px;
              background-image: url('../../assets/icon-arrow-left.svg');
            }
          }
        }
      }
    }

    .btn-group {
      position: absolute;
      top: 450px;
    }

    // FILTER

    .mumblfilter {
      transition: transform 0.15s ease-in-out;
      -webkit-box-shadow: 0px 0px 10px 4px rgba(0, 0, 0, 0.2);
      -moz-box-shadow: 0px 0px 10px 4px rgba(0, 0, 0, 0.2);
      box-shadow: 0px 0px 10px 4px rgba(0, 0, 0, 0.2);
      position: absolute;
      overflow: inherit;
      z-index: 2;
      top: 0;
      left: 0;
      transform: translateX(-100%);
      width: 100%;
      max-width: 480px;
      height: 100%;

      @include medium {
        transform: translateX(-100%);
        width: 360px;
      }

      &.is-active {
        transform: translateX(0%);

        .btn-floating {
          transition: right 0.15s ease-in-out;

          &.trigger {
            right: 15px;

            @include medium {
              right: -30px;
            }

            .icon {
              background-image: url('../../assets/icon-close-02.svg');
              top: 0;
              width: 22px;
              height: 22px;

              @include medium {
                width: 24px;
                height: 24px;
              }
            }
          }
        }
      }

      &__inner {
        height: 100%;
        overflow-y: auto;
        padding: 2rem 3rem 3rem 2rem;

        @include medium {
          padding: 4rem 5rem 4rem 4rem;
        }
      }

      h2 {
        margin-top: 0;
        margin-bottom: 1.2em;
        font-family: 'Titillium Web', sans-serif;
        font-weight: 700;
        font-size: 1.8rem;
        color: $c-white;
      }

      .btn-floating {
        transition: opacity 0.1s ease-in-out, background-color 0.05s ease-in-out, right 0.15s ease-in-out;
        -webkit-box-shadow: 0px 0px 10px 4px rgba(0, 0, 0, 0.1);
        -moz-box-shadow: 0px 0px 10px 4px rgba(0, 0, 0, 0.1);
        box-shadow: 0px 0px 10px 4px rgba(0, 0, 0, 0.1);
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;

        &.trigger {
          top: 15px;
          right: -120px;
          width: 50px;
          height: 50px;

          @include medium {
            top: 120px;
            right: -90px;
            width: 70px;
            height: 70px;
          }

          .icon {
            position: relative;
            top: 6px;
            pointer-events: none;
            background-repeat: no-repeat;
            background-size: contain;
            background-image: url('../../assets/icon-filter.svg');
            width: 26px;
            height: 26px;

            @include medium {
              top: 8px;
              width: 36px;
              height: 36px;
            }
          }
        }

        &.is-hidden {
          pointer-events: none;
          opacity: 0;
        }
      }

      &__gender {
        opacity: 0.3;
        cursor: pointer;
        display: flex;
        align-items: center;
        margin-bottom: 1rem;

        &.is-active {
          opacity: 1;
        }
      }

      &__gender-text {
        pointer-events: none;
        transition: background 0.15s ease-in-out;
        margin-left: 20px;
        font-family: 'Lobster', cursive;
        font-size: 1.8rem;
        color: $c-white;
      }

      &__btn {
        pointer-events: none;
        transition: background 0.15s ease-in-out;
        -webkit-box-shadow: 0px 0px 10px 4px rgba(0, 0, 0, 0.05);
        -moz-box-shadow: 0px 0px 10px 4px rgba(0, 0, 0, 0.05);
        box-shadow: 0px 0px 10px 4px rgba(0, 0, 0, 0.05);
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 60px;
        height: 60px;
        border-radius: 50%;

        @include medium {
          width: 70px;
          height: 70px;
        }
      }

      &__btn-icon {
        pointer-events: none;
        display: block;
        background-repeat: no-repeat;
        background-size: contain;
        width: 40px;
        height: 40px;

        @include medium {
          width: 45px;
          height: 45px;
        }

        &.all {
          background-image: url('../../assets/icon-mumbl-unisex.svg');
        }

        &.male {
          background-image: url('../../assets/icon-mumbl-male.svg');
        }

        &.female {
          background-image: url('../../assets/icon-mumbl-female.svg');
        }

        &.unisex {
          background-image: url('../../assets/icon-mumbl-unisex.svg');
        }
      }
    }

    // FAVORITES

    .mumblfav-wrapper {
      transition: transform 0.15s ease-in-out;
      -webkit-box-shadow: 0px 0px 10px 4px rgba(0, 0, 0, 0.2);
      -moz-box-shadow: 0px 0px 10px 4px rgba(0, 0, 0, 0.2);
      box-shadow: 0px 0px 10px 4px rgba(0, 0, 0, 0.2);
      position: absolute;
      overflow: inherit;
      z-index: 2;
      top: 0px;
      left: 0px;
      transform: translateX(-100%);
      width: 100%;
      max-width: 480px;
      height: 100%;

      @include medium {
        width: 400px;
      }

      &.is-active {
        transform: translateX(0%);

        .btn-floating {
          transition: right 0.15s ease-in-out;

          &.trigger {
            right: 15px;

            @include medium {
              right: -30px;
            }

            .icon {
              background-image: url('../../assets/icon-close-02.svg');
              top: 0;
              width: 20px;
              height: 20px;

              @include medium {
                width: 24px;
                height: 24px;
              }
            }
          }
        }
      }

      &__inner {
        position: relative;
        height: 100%;
        //overflow-y: auto;
        overflow: hidden;
        padding: 2rem 3rem 3rem 2rem;

        @include medium {
          padding: 4rem 5rem 4rem 4rem;
        }

        &:hover {

          .ps__thumb-y {
            @include medium {
              opacity: 0.1;
            }
          }
        }

        .ps__rail-y {
          background: transparent;
          position: absolute;
          left: 0;
          right: auto;
          z-index: 5;
          width: 8px;
          margin-top: 5px;
          margin-left: 5px;
        }

        .ps__thumb-y {
          transition: opacity 0.15s ease-in-out;
          opacity: 0;
          position: relative;
          background: $c-white;
          border-radius: 10px;

          @include medium {
            opacity: 0;
          }
        }
      }

      h2 {
        margin-top: 0;
        margin-bottom: 1em;
        font-family: 'Titillium Web', sans-serif;
        font-weight: 700;
        font-size: 1.8rem;
        color: $c-white;
      }


      li {
        max-width: 240px;
        font-size: 1.2rem;
        font-weight: 600;

        @include small {
          max-width: 300px;
        }
      }

      .btn-floating {
        transition: right 0.15s ease-in-out;
        -webkit-box-shadow: 0px 0px 10px 4px rgba(0, 0, 0, 0.1);
        -moz-box-shadow: 0px 0px 10px 4px rgba(0, 0, 0, 0.1);
        box-shadow: 0px 0px 10px 4px rgba(0, 0, 0, 0.1);
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;

        &.trigger {
          top: 15px;
          right: -60px;
          width: 50px;
          height: 50px;

          @include medium {
            top: 30px;
            right: -90px;
            width: 70px;
            height: 70px;
          }

          .icon {
            position: relative;
            top: 4px;
            pointer-events: none;
            background-repeat: no-repeat;
            background-size: contain;
            background-image: url('../../assets/icon-heart.svg');
            width: 26px;
            height: 26px;

            @include medium {
              width: 36px;
              height: 36px;
            }
          }
        }
      }

      .mumblfav {
        -webkit-box-shadow: 0px 0px 4px 3px rgba(0, 0, 0, 0.1);
        -moz-box-shadow: 0px 0px 4px 3px rgba(0, 0, 0, 0.1);
        box-shadow: 0px 0px 4px 3px rgba(0, 0, 0, 0.1);

        &__inner {
          padding: 10px 40px 15px 44px;
        }

        &__name {
          font-family: 'Lobster', cursive;
          font-size: 1.6rem;
          font-weight: normal;
        }

        &__toggle {
          display: block;
        }

        &__origin {
          opacity: 0.8;
          margin-top: 0px;
          font-family: 'Fira Sans', sans-serif;
          font-size: 1.1rem;
          font-weight: normal;
          font-style: italic;
          color: $c-white;
        }

        &__meaning {
          display: none;
          font-family: 'Titillium Web', sans-serif;
          font-size: 1rem;
          font-weight: normal;
          color: $c-white;
          opacity: 0.7;
        }

        &__icon-wrapper {
          // display: inline-block;
          // width: 50px;
          // height: 50px;
          -webkit-box-shadow: 0px 0px 10px 4px rgba(0, 0, 0, 0.1);
          -moz-box-shadow: 0px 0px 10px 4px rgba(0, 0, 0, 0.1);
          box-shadow: 0px 0px 10px 4px rgba(0, 0, 0, 0.1);
          display: flex;
          align-items: center;
          justify-content: center;
          position: absolute;
          transform: translate(40%, -50%);
          width: 50px;
          height: 50px;
          border-radius: 50%;
          right: 0;
          top: 50%;

          .icon {
            background-repeat: no-repeat;
            background-size: contain;
            background-position: bottom;
            // position: relative;
            // top: 6px;
            // right: -15px;
            width: 30px;
            height: 30px;

            &.male {
              background-image: url('../../assets/icon-mumbl-male.svg');
            }

            &.female {
              background-image: url('../../assets/icon-mumbl-female.svg');
            }

            &.unisex {
              background-image: url('../../assets/icon-mumbl-unisex.svg');
            }
          }
        }

        .btn-floating {
          position: absolute;
          top: 50%;

          &.more {
            display: none;
            right: 0;
            transform: translate(40%, -50%);

            &.is-active {

              .icon {
                transform: rotate(180deg);
              }
            }

            .icon {
              transition: transform 0.15s ease-in-out;
              pointer-events: none;
            }
          }

          &.delete {
            transition: background 0.15s ease-in-out;
            left: 0;
            transform: translate(-40%, -50%);

            // &:hover {
            //
            //     .icon {
            //         opacity: 1;
            //     }
            // }

            .icon {
              opacity: 0.8;
            }
          }
        }
      }
    }
  }


  // SPINNER
  .spinner {
    position: absolute;
    z-index: 20;
    top: 40%;
    left: 50%;
    transform: translateX(-50%);
    margin: 100px auto 0;
    width: 70px;
    text-align: center;
  }

  .spinner > div {
    opacity: 0.6;
    width: 18px;
    height: 18px;
    background-color: $c-white;
    border-radius: 100%;
    display: inline-block;
    -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
    animation: sk-bouncedelay 1.4s infinite ease-in-out both;
  }

  .spinner .bounce1 {
    -webkit-animation-delay: -0.32s;
    animation-delay: -0.32s;
  }

  .spinner .bounce2 {
    -webkit-animation-delay: -0.16s;
    animation-delay: -0.16s;
  }

  @-webkit-keyframes sk-bouncedelay {
    0%, 80%, 100% {
      -webkit-transform: scale(0)
    }
    40% {
      -webkit-transform: scale(1.0)
    }
  }

  @keyframes sk-bouncedelay {
    0%, 80%, 100% {
      -webkit-transform: scale(0);
      transform: scale(0);
    }
    40% {
      -webkit-transform: scale(1.0);
      transform: scale(1.0);
    }
  }


</style>



// WEBPACK FOOTER //
// src/components/frontend/ShowMumblCard.vue